<template>
  <div
    class="candidates-worksheet-status-icon"
    :class="{
      'with-link': withLink,
    }"
  >
    <div class="worksheet-icon" @click="goToWorksheet">
      <div
        v-if="worksheetStatus === 'warning'"
        :id="`c-table-actions__action-worksheet-warning-${recordIndex}`"
        class="c-table-actions__icon"
      >
        <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1 4V3H0V4H1ZM1 16H0V17H1V16ZM11 16V17H12V16H11ZM11 4H12V3H11V4ZM5 10C5 10.5523 5.44772 11 6 11C6.55228 11 7 10.5523 7 10H5ZM7 7C7 6.44772 6.55228 6 6 6C5.44772 6 5 6.44772 5 7H7ZM0 4V16H2V4H0ZM1 17H11V15H1V17ZM10 4V16H12V4H10ZM1 5H11V3H1V5ZM7 10V7H5V10H7Z"
            fill="#FFB800"
          />
          <path d="M4 4.5V1H14V13H11" stroke="#FFB800" stroke-width="2" />
          <circle cx="6" cy="13" r="1" fill="#FFB800" />
        </svg>
      </div>
      <div
        v-if="worksheetStatus === 'success'"
        :id="`c-table-actions__action-worksheet-success-${recordIndex}`"
        class="c-table-actions__icon"
      >
        <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1 4V3H0V4H1ZM1 16H0V17H1V16ZM11 16V17H12V16H11ZM11 4H12V3H11V4ZM4.70711 9.29289C4.31658 8.90237 3.68342 8.90237 3.29289 9.29289C2.90237 9.68342 2.90237 10.3166 3.29289 10.7071L4.70711 9.29289ZM5 11L4.29289 11.7071C4.68342 12.0976 5.31658 12.0976 5.70711 11.7071L5 11ZM8.70711 8.70711C9.09763 8.31658 9.09763 7.68342 8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289L8.70711 8.70711ZM14 1H15V0H14V1ZM14 13V14H15V13H14ZM4 1V0H3V1H4ZM0 4V16H2V4H0ZM1 17H11V15H1V17ZM10 4V16H12V4H10ZM1 5H11V3H1V5ZM3.29289 10.7071L4.29289 11.7071L5.70711 10.2929L4.70711 9.29289L3.29289 10.7071ZM5.70711 11.7071L8.70711 8.70711L7.29289 7.29289L4.29289 10.2929L5.70711 11.7071ZM13 1V13H15V1H13ZM4 2H14V0H4V2ZM3 1V4.5H5V1H3ZM11 14H14V12H11V14Z"
            fill="#12C971"
          />
        </svg>
      </div>

      <div
        v-if="worksheetStatus === 'error'"
        :id="`c-table-actions__action-worksheet-error-${recordIndex}`"
        class="c-table-actions__icon"
      >
        <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1 4V3H0V4H1ZM1 16H0V17H1V16ZM11 16V17H12V16H11ZM11 4H12V3H11V4ZM4.70711 7.29289C4.31658 6.90237 3.68342 6.90237 3.29289 7.29289C2.90237 7.68342 2.90237 8.31658 3.29289 8.70711L4.70711 7.29289ZM7.29289 12.7071C7.68342 13.0976 8.31658 13.0976 8.70711 12.7071C9.09763 12.3166 9.09763 11.6834 8.70711 11.2929L7.29289 12.7071ZM8.70711 8.70711C9.09763 8.31658 9.09763 7.68342 8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289L8.70711 8.70711ZM3.29289 11.2929C2.90237 11.6834 2.90237 12.3166 3.29289 12.7071C3.68342 13.0976 4.31658 13.0976 4.70711 12.7071L3.29289 11.2929ZM14 1H15V0H14V1ZM14 13V14H15V13H14ZM4 1V0H3V1H4ZM0 4V16H2V4H0ZM1 17H11V15H1V17ZM10 4V16H12V4H10ZM1 5H11V3H1V5ZM3.29289 8.70711L5.29289 10.7071L6.70711 9.29289L4.70711 7.29289L3.29289 8.70711ZM5.29289 10.7071L7.29289 12.7071L8.70711 11.2929L6.70711 9.29289L5.29289 10.7071ZM7.29289 7.29289L5.29289 9.29289L6.70711 10.7071L8.70711 8.70711L7.29289 7.29289ZM5.29289 9.29289L3.29289 11.2929L4.70711 12.7071L6.70711 10.7071L5.29289 9.29289ZM13 1V13H15V1H13ZM4 2H14V0H4V2ZM3 1V4.5H5V1H3ZM11 14H14V12H11V14Z"
            fill="#FF238D"
          />
        </svg>
      </div>
    </div>

    <b-popover
      v-if="worksheetStatus === 'success'"
      triggers="hover"
      :target="`c-table-actions__action-worksheet-success-${recordIndex}`"
    >
      Анкета заполнена
    </b-popover>

    <b-popover
      v-if="worksheetStatus === 'error'"
      triggers="hover"
      :target="`c-table-actions__action-worksheet-error-${recordIndex}`"
    >
      Анкета не заполнена
    </b-popover>

    <b-popover
      v-if="worksheetStatus === 'warning'"
      triggers="hover"
      :target="`c-table-actions__action-worksheet-warning-${recordIndex}`"
    >
      <div class="c-table-actions__worksheet-tooltip">
        <div class="c-table-actions__worksheet-tooltip-title">Заполнено</div>
        <table>
          <tr>
            <td class="c-table-actions__worksheet-tooltip-meta">Обязательных полей</td>
            <td>{{ required !== undefined ? required.count : null }}</td>
            <td>{{ required !== undefined ? required.percentage : null }}%</td>
          </tr>

          <tr>
            <td class="c-table-actions__worksheet-tooltip-meta">Дополнительных полей</td>
            <td>{{ additional !== undefined ? additional.count : null }}</td>
            <td>{{ additional !== undefined ? additional.percentage : null }}%</td>
          </tr>

          <tr>
            <td class="c-table-actions__worksheet-tooltip-meta">Всего</td>
            <td>{{ total !== undefined ? total.count : null }}</td>
            <td>{{ total !== undefined ? total.percentage : null }}%</td>
          </tr>
        </table>
      </div>
    </b-popover>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { formatCandidateMeta } from "@/helpers/candidatesFunctions";

export default {
  name: "candidates-worksheet-status",
  props: {
    candidate: {
      type: Object,
      required: true,
    },
    recordIndex: {
      type: Number,
      default: 0,
    },
    candidateId: {
      type: Number,
      default: 0,
    },
    withLink: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      total: null,
      required: null,
      additional: null,
    };
  },
  computed: {
    ...mapGetters({
      getCandidateWorksheet: "candidates/getCandidateWorksheet",
    }),
    worksheetStatus() {
      let status = "error";

      if (this.total && this.required && this.additional) {
        status = "warning";

        if (this.total.percentage === 100 &&
          this.required.percentage === 100 &&
          this.additional.percentage === 100) {
          status = "success";
        }
      }

      return status;
    },
  },
  created() {
    let candidateWorksheet =
      this.candidate._meta ? this.candidate._meta : formatCandidateMeta(this.candidate);

    if (!candidateWorksheet && this.candidateId) {
      candidateWorksheet = this.getCandidateWorksheet(this.candidateId);
    }


    this.total =
      candidateWorksheet.questCompletion ? candidateWorksheet.questCompletion.total : null;
    this.required =
      candidateWorksheet.questCompletion ? candidateWorksheet.questCompletion.required_fields : null;
    this.additional =
      candidateWorksheet.questCompletion ? candidateWorksheet.questCompletion.additional_fields : null;
  },
  methods: {
    goToWorksheet() {
      //alert(this.candidate.id);
      if (!this.withLink) {
        return;
      }
      this.$router.push({
        name: "candidates-profile",
        params: {
          id: this.candidate.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.candidates-worksheet-status-icon.with-link {
  cursor: pointer;
}

.c-table-actions {
  &__worksheet-tooltip {
    text-align: left;

    &-title {
      font-weight: 500;
      margin: 5px;
    }

    &-meta {
      color: $color-label;
      white-space: nowrap;
      font-weight: normal !important;
    }

    td {
      padding: 5px;
      font-weight: 500;
    }
  }
}
.worksheet-icon {
  margin-bottom: 5px;
}
</style>
